export default {
  validity: 'Vigencia',
  validityTooltip: 'Al estar vigente la {strategy} será visible en {matrix}.',
}
